@if (profile) {
  <div class="mx-auto max-w-4xl px-4 pt-6 text-center sm:flex sm:pt-16 sm:text-left">
    <div class="items-center sm:mr-16 sm:flex sm:items-start">
      <div class="mx-auto w-36">
        <rma-profile-avatar
          class="h-36 w-36 shrink-0 border-4 border-white"
          [size]="144"
          [avatar]="profile.avatarImage"
          [backgroundColour]="profile.backgroundColour"
          [name]="profile.fullName"
          [lazyLoad]="false"
        />
      </div>
      <div class="mt-4 sm:ml-8 sm:mt-0" [ngClass]="{ 'sm:py-10': !profile.agentOverallStars && !profile.reviewCount }">
        <div class="mb-2 text-2xl font-bold">{{ profile.fullName }}</div>
        <div class="text-lg font-bold">{{ profile.agencyName }}</div>
        @if (profile.agentOverallStars && profile.reviewCount) {
          <div class="mt-4 flex justify-center sm:mt-5 sm:justify-start">
            <rma-star-rating-summary class="mr-2" [overallStars]="profile.agentOverallStars" />
            <p>{{ 'review.count' | transloco: { count: profile.reviewCount } }}</p>
          </div>
        }
        <rma-market-report-top-award [awards]="awards" />
      </div>
    </div>
    <div class="mx-auto my-6 flex w-64 flex-col gap-4 sm:mx-0 sm:my-0" [ngClass]="{ 'sm:py-14': !profile.contactNumber }">
      @if (profile.email) {
        <a class="hidden md:flex" [href]="'mailto:' + profile.email" mat-flat-button color="primary">
          {{ 'button.label.get-in-touch' | transloco }}
        </a>
      }
      @if (profile.contactNumber) {
        <a class="hidden bg-white md:flex" [href]="'tel:' + profile.contactNumber" mat-stroked-button color="primary">
          {{ profile.contactNumber }}
        </a>
      }
    </div>
  </div>
  <div class="mx-auto my-6 flex items-center justify-center text-lg font-bold">
    <span class="mr-2">{{ 'marketReports.powered-by' | transloco }}</span
    ><img alt="RateMyAgent" [src]="'/logos/logo-dark.svg' | staticImageUrl" width="111" height="32" />
  </div>
  <div class="h-2 w-full" [style.background-color]="profile.backgroundColour ?? '#1a222c'"></div>
}
